import type { StrapiMagazineArticle } from '~/composables/types/strapi/strapi-magazine'
import { articleGetters } from '~/utils/articleGetters'

export const useMagazineArticleLocaleSwitcher = (
  article: StrapiMagazineArticle | null | undefined
) => {
  const buildLocaleUrl = (targetLocale: string): string | null => {
    if (!article) return null

    const normalizedTargetLocale = targetLocale.toLowerCase()
    const currentLocale = articleGetters.getLocale(article)?.toLowerCase()

    if (currentLocale === normalizedTargetLocale) return null

    const localizations = articleGetters.getLocalizations(article)

    if (!localizations?.length) return null

    const targetLocalization = localizations.find(
      (loc) => loc.locale?.toLowerCase() === normalizedTargetLocale
    )

    if (!targetLocalization?.slug) return null

    const localePrefix = targetLocale.toLowerCase()
    return `/${localePrefix}/magazine/${targetLocalization.slug}/`
  }

  const hasOtherLocales = (): boolean => {
    if (!article) return false
    const localizations = articleGetters.getLocalizations(article)
    if (!localizations?.length) return false
    const currentLocale = articleGetters.getLocale(article)?.toLowerCase()
    return localizations.some(
      (loc) => loc.locale?.toLowerCase() !== currentLocale
    )
  }

  return {
    buildLocaleUrl,
    hasOtherLocales,
  }
}
